import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";

const STEPS = [
  { title: "Approbation", caption: "du dossier" },
  { title: "Mise en place", caption: "du financement" },
  { title: "Contrats", caption: "et signatures" },
  { title: "Livraison", caption: "du véhicule" },
  { title: "Suivi", caption: "des paiements" },
];

const DossierSteps = ({ activeStep, completedThrough = activeStep - 1 }) => (
  <Box component="nav" aria-label="Étapes du dossier" sx={{ flex: 1, minWidth: 0, width: "100%" }}>
    <Box component="ol" sx={{ display: "grid", gridTemplateColumns: "repeat(5, minmax(0, 1fr))", listStyle: "none", m: 0, p: "5px 0", rowGap: 1 }}>
      {STEPS.map((step, index) => {
        const number = index + 1;
        const active = number === activeStep;
        const done = number <= completedThrough;
        return (
          <Box component="li" key={step.title} aria-current={active ? "step" : undefined} aria-label={`Étape ${number} : ${step.title} ${step.caption}`} sx={{ position: "relative", display: "flex", alignItems: "center", flexDirection: "column", textAlign: "center", minWidth: 0 }}>
            {index > 0 && <Box aria-hidden="true" sx={{ position: "absolute", top: 16, left: "-50%", width: "100%", height: "1px", bgcolor: number <= Math.max(activeStep, completedThrough) ? "#13805f" : "#d1dae2" }} />}
            <Box aria-hidden="true" sx={{ zIndex: 1, display: "flex", alignItems: "center", justifyContent: "center", width: 32, height: 32, mb: 1, borderRadius: "50%", color: active || done ? "#fff" : "#6d7e90", bgcolor: active || done ? "#0e805d" : "#e8edf1", boxShadow: active ? "0 0 0 4px rgba(14,128,93,.11)" : "none", fontSize: 13, fontWeight: 800, "& .MuiSvgIcon-root": { fontSize: 21 } }}>
              {number === 5 ? <PaymentsOutlinedIcon /> : done ? <CheckCircleRoundedIcon /> : number}
            </Box>
            <Typography sx={{ color: "#34485d", fontSize: { xs: "10px !important", sm: "12px !important" }, lineHeight: "1.35 !important", fontWeight: "700 !important" }}>{step.title}</Typography>
            <Typography sx={{ color: "#6c7c8e", fontSize: { xs: "9px !important", sm: "11px !important" }, lineHeight: "1.4 !important" }}>{step.caption}</Typography>
          </Box>
        );
      })}
    </Box>
  </Box>
);

export default DossierSteps;
